<template>
  <section class="flex flex-col items-center gap-200" :class="{ outlined }">
    <div
      v-if="$slots.headline || $slots.subtitle"
      class="headline-container flex flex-col items-center w-full"
      :class="smallerHeadlineSpacing || empty ? 'gap-050' : 'gap-200'"
    >
      <component :is="headlineTag" v-if="$slots.headline" class="headline-h4-headline">
        <slot name="headline" />
      </component>
      <p v-if="$slots.subtitle" class="subtitle text-center" :class="{ secondary: empty }">
        <slot name="subtitle" />
      </p>
    </div>

    <Illustration v-bind="{ alt }" :name="illustration" />

    <slot name="description" />

    <slot />
  </section>
</template>

<script lang="ts" setup>
import type { IllustrationProps } from '~/components/Illustration/Illustration.vue'

type IllustratedSectionProps = {
  alt?: string
  empty?: boolean
  headlineTag?: 'h1' | 'h2' | 'h3' | 'h4'
  illustration: IllustrationProps['name']
  outlined?: boolean
  smallerHeadlineSpacing?: boolean
}

const {
  alt = '',
  headlineTag = 'h1',
  smallerHeadlineSpacing = false,
} = defineProps<IllustratedSectionProps>()
</script>

<style lang="scss" scoped>
.subtitle {
  max-width: calc($main-content-width / 2);

  &.secondary {
    color: token('color/text/secondary/secondary');
  }
}

.outlined {
  padding: token('size/space/gap/300') token('size/space/gap/200');
  border: token('size/border/100') token('color/border/primary/primary') solid;
  border-radius: token('size/radius/l');
}
</style>
